import { Routes } from '@angular/router';
import { AuthModule } from '@os-components';
import { ArticleComponent } from './features/article/article.component';
import { AuthorComponent } from './features/author/author.component';
import { LandingPageComponent } from './features/landing-page/landing-page.component';

export const routes: Routes = [
    { path: 'posts', component: ArticleComponent, children: [{ path: '**', component: ArticleComponent }] },
    { path: 'author/:authorFirstName/:authorLastName', component: AuthorComponent },
    {
        path: 'auth',
        loadChildren: () => AuthModule,
    },
    { path: '**', component: LandingPageComponent },
];
